document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".magazine-single-page")) {
    // Find the first element with class "introtext"
    var firstIntroText = document.querySelector(".introtext");

    if (firstIntroText) {
      firstIntroText.style.fontSize = "32px";
      firstIntroText.style.lineHeight = "40px";
      firstIntroText.style.fontWeight = "300";
      firstIntroText.style.marginBottom= "3rem";
    }
  }
});
